import React,{ useState, useEffect, useRef } from "react";
import {
  useNavigate,
  useLocation
} from "react-router-dom";
import { isMobile } from 'mobile-device-detect';
import { gsap } from "gsap/all";
//import { useLoadApi } from '../store/preloaderstore'
import Lottie from 'react-lottie-player'
import lottieJson from './../lotties/saycheese.json'

import VideoBackgroundCover from './../components/VideoBackgroundCover'

export default function InstructVideo1() {
  let navigate = useNavigate();

  const page = useRef(null);
  
  useEffect(() => {
//    if(window.location.href.indexOf("lentfertnuc")>-1) gsap.delayedCall(0,()=>{ navigate("/takepicture") })
  },[]);
  
  const adjustIframeHeight = () => {
    const ph = gsap.getProperty(page.current,"height")
    console.log(ph,window.innerHeight)
    if(window !== window.parent) gsap.set(window.parent,{"height":ph})
  }

  const lottieCompleted = () =>{
    gsap.delayedCall(0,()=>{
      navigate("/takepicture")
    })
  }

  const onEnterFrame = (fr) => {
//    console.log(fr)
    if(fr.currentTime > 94) {
      navigate("/takepicture")
    }
  }

  return (
    <div className="page" ref={page}>

      <Lottie
        loop={false}
        play
        animationData={lottieJson}
        renderer="svg"
        onEnterFrame={onEnterFrame}
        speed={1.2}
//        onComplete={lottieCompleted}
        style={{ position:"absolute", width:"100%", zIndex:20,  pointerEvents:"none" }}
      />

      <VideoBackgroundCover />
    </div>
  );
}
